import { render, staticRenderFns } from "./stdcost.vue?vue&type=template&id=7b366fd0&scoped=true&"
import script from "./stdcost.vue?vue&type=script&lang=js&"
export * from "./stdcost.vue?vue&type=script&lang=js&"
import style0 from "./stdcost.vue?vue&type=style&index=0&id=7b366fd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b366fd0",
  null
  
)

export default component.exports